<script>
	import { Facebook, Instagram, Linkedin, Mail, Youtube } from 'lucide-svelte';
	import Button from './ui/button/button.svelte';

	import MailingList from './nav/MailingList.svelte';
</script>

<footer class="mx-auto mt-8 grid max-w-screen-2xl grid-cols-1 border-t px-4 lg:grid-cols-4">
	<div class=" mt-8 hidden items-center justify-center lg:mt-0 lg:flex lg:flex-col">
		<a href="/" aria-label="tassie tours logo" data-sveltekit-noscroll>
			<enhanced:img
				src="/src/lib/assets/logo/logo-black.png?w=336;288"
				class="h-24 w-auto lg:h-28"
				alt="Tassie Tours Logo"
				loading="lazy"
				sizes="(min-width: 1024px) 336px, 288px"
			/>
		</a>
		<p
			class="lg:text-md max-w-2xl text-center text-sm font-medium italic leading-7 [&:not(:first-child)]:mt-6"
		>
			We acknowledge the Tasmanian Aboriginal community as the continuing custodians of lutruwita
			(Tasmania) and honour Aboriginal Elders past and present.
		</p>
	</div>
	<div class="col-span-2 mx-auto max-w-7xl overflow-hidden py-12 lg:px-8">
		<div class="flex w-full flex-col items-center justify-center">
			<MailingList />

			<Button
				href="/tours#dayTours"
				data-sveltekit-noscroll
				class=" rounded-full bg-tt-red px-6 text-lg font-semibold hover:bg-tt-red/90"
				>Book now</Button
			>

			<p
				class=" max-w-2xl text-center text-sm font-medium italic leading-7 lg:hidden [&:not(:first-child)]:mt-6"
			>
				We acknowledge the Tasmanian Aboriginal community as the continuing custodians of lutruwita
				(Tasmania) and honour Aboriginal Elders past and present.
			</p>

			<div class="mt-8 flex justify-center space-x-4">
				<Button
					variant="ghost"
					size="icon"
					href="https://www.facebook.com/tassietours"
					target="_blank"
					class="rounded-full text-gray-400 hover:text-gray-500"
				>
					<span class="sr-only">Facebook</span>
					<Facebook class="!h-6 !w-6" />
				</Button>

				<Button
					variant="ghost"
					size="icon"
					href="https://www.youtube.com/channel/UCt4v21_RuhUY8NPJXzkaLaA"
					target="_blank"
					class="rounded-full text-gray-400 hover:text-gray-500"
				>
					<span class="sr-only">YouTube</span>
					<Youtube class="!h-7 !w-7" />
				</Button>
				<Button
					variant="ghost"
					size="icon"
					href="https://www.instagram.com/tassietours_tasmania/"
					target="_blank"
					class="rounded-full text-gray-400 hover:text-gray-500"
				>
					<span class="sr-only">Instagram</span>
					<Instagram class="!h-6 !w-6" />
				</Button>
				<Button
					variant="ghost"
					size="icon"
					href="https://www.tiktok.com/@tassietours"
					target="_blank"
					class="rounded-full text-gray-400 hover:text-gray-500"
				>
					<span class="sr-only">TikTok</span>
					<svg
						class="!h-6 !w-6"
						viewBox="0 0 24 24"
						fill="currentColor"
						xmlns="http://www.w3.org/2000/svg"
						aria-hidden="true"
					>
						<path
							d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.6-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"
						/>
					</svg>
				</Button>
				<Button
					variant="ghost"
					size="icon"
					href="mailto:info@tassietours.com"
					class="rounded-full text-gray-400 hover:text-gray-500"
				>
					<span class="sr-only">Email</span>
					<Mail class="!h-6 !w-6" />
				</Button>
			</div>
			<p class="mt-2 hidden text-center text-xs text-foreground/60 lg:block">
				© 2026 TASSIE TOURS TASMANIA. ALL RIGHTS RESERVED | <Button
					data-sveltekit-noscroll
					class="px-0 text-xs text-foreground/60"
					variant="link"
					href="/legal">PRIVACY</Button
				> | <Button
					data-sveltekit-noscroll
					class="px-0 text-xs text-foreground/60"
					variant="link"
					href="/legal">TERMS</Button
				> |
			</p>
			<p class="mt-2 text-center text-xs text-foreground/60 lg:hidden">
				© 2026 TASSIE TOURS TASMANIA. ALL RIGHTS RESERVED <br />
				<Button
					data-sveltekit-noscroll
					class="px-0 text-xs text-foreground/60"
					variant="link"
					href="/legal">PRIVACY</Button
				> | <Button
					data-sveltekit-noscroll
					class="px-0 text-xs text-foreground/60"
					variant="link"
					href="/legal">TERMS</Button
				>
			</p>
			<a
				href="https://haruassembly.com/"
				target="_blank"
				class="group mt-2 flex items-center justify-center gap-2 text-sm text-foreground/60"
			>
				<p class="group-hover:underline">site by</p>
				<svg
					class="h-5 w-5 fill-foreground"
					width="300"
					height="295"
					viewBox="0 0 300 295"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M222.06 0.621887C207.924 3.45187 198.268 16.7043 198.268 31.1209V93.497C198.268 106.489 187.738 117.02 174.746 117.02H83.5089C70.5189 117.02 59.9864 106.489 59.9864 93.497V31.123C59.9864 16.7065 50.3322 3.45187 36.195 0.621887C16.9164 -3.23892 0 11.4021 0 29.9928V262.902C0 277.321 9.65625 290.574 23.7914 293.404C43.0721 297.264 59.9864 282.625 59.9864 264.033V187.687C59.9864 174.697 70.5189 164.166 83.5089 164.166H174.746C187.738 164.166 198.268 174.697 198.268 187.687V262.905C198.268 277.321 207.924 290.574 222.06 293.404C241.34 297.264 258.255 282.623 258.255 264.033V29.9928C258.255 11.4021 241.34 -3.23892 222.06 0.621887Z"
					/>
				</svg>
			</a>
		</div>
	</div>
	<div class="hidden items-center justify-center lg:flex">
		<a
			href="https://accreditation.qualitytourismaustralia.com/report/AccessReportPublicHtml2/40eefd8a-e686-4848-8962-809eb37bb0ab"
			target="_blank"
			aria-label="Quality Tourism Accredited Business"
			data-sveltekit-noscroll
		>
			<enhanced:img
				src="/src/lib/assets/images/QTAB.png?w=220;176"
				class="h-44 w-auto"
				alt="Quality Tourism Accredited Business"
				loading="lazy"
				sizes="(min-width: 1024px) 220px, 176px"
			/>
		</a>
	</div>
</footer>
